import { render } from "./Add.vue?vue&type=template&id=37bd5588"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=37bd5588&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/homeWorks/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37bd5588"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37bd5588', __exports__)) {
    console.log('reload')
    api.reload('37bd5588', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=37bd5588", () => {
    console.log('re-render')
    api.rerender('37bd5588', render)
  })

}


export default __exports__